import { v4 as uuidv4 } from 'uuid';
let uuid = uuidv4();
let increasingInteger = 0;
/**
 * Produces a unique identifier in a high performance way.
 *
 * It uses an increasing integer concatenated with a UUID (that's expensive to create) and re-uses that same UUID until
 * we exceed the maximum integer value possible, and only at that time, re-produce the UUID.
 *
 * @returns A unique identifier to attach to a log
 */
export function generateUniqueId() {
    if (increasingInteger === Number.MAX_SAFE_INTEGER) {
        uuid = uuidv4();
        increasingInteger = 0;
    }
    const id = `${increasingInteger}_${uuid}`;
    increasingInteger++;
    return id;
}
/**
 * !IMPORTANT! This should only be used in testing scenarios.
 *
 * @param startValue An integer to offset from where the unique identifier starts for test validation.
 */
export function setOffsetStart(startValue) {
    increasingInteger = startValue;
}
//# sourceMappingURL=generateUniqueId.js.map